export type ConnectionIdentity = "authenticated" | "anonymous" | "none";

export interface ResolveDesiredIdentityArgs {
  pathname: string;
  isClerkLoaded: boolean;
  isSignedIn: boolean;
}

/**
 * Single source of truth for which identity the WebSocket should carry.
 *
 * - "none" while Clerk hasn't finished loading — connecting before auth state
 *   is known is what created anonymous-owned threads for signed-in users.
 * - Signed-in users are "authenticated" on every route, including /try
 *   (they get redirected off /try, but must never hold an anonymous socket).
 * - "anonymous" only for resolved signed-out visitors on /try.
 */
export const resolveDesiredIdentity = ({
  pathname,
  isClerkLoaded,
  isSignedIn,
}: ResolveDesiredIdentityArgs): ConnectionIdentity => {
  if (!isClerkLoaded) {
    return "none";
  }
  if (isSignedIn) {
    return "authenticated";
  }
  return pathname === "/try" ? "anonymous" : "none";
};
